var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    fill: "none",
    viewBox: "0 0 30 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M13.165 2.541c-.95 0-1.757.66-1.984 1.55h7.625a2.058 2.058 0 0 0-1.984-1.55h-3.657Zm7.796 1.55h2.806c2.977 0 5.4 2.453 5.4 5.466 0 0-.085 1.275-.113 3.051a.467.467 0 0 1-.183.362 24.71 24.71 0 0 1-1.362.948c-2.353 1.578-5.087 2.689-8 3.24a.45.45 0 0 1-.473-.23 4.67 4.67 0 0 0-4.042-2.336c-1.69 0-3.23.911-4.07 2.327a.452.452 0 0 1-.47.227c-2.889-.554-5.623-1.663-7.962-3.214l-1.36-.946a.405.405 0 0 1-.185-.345C.905 11.91.834 9.557.834 9.557c0-3.013 2.424-5.466 5.4-5.466h2.792C9.296 2.011 11.04.39 13.166.39h3.656c2.126 0 3.87 1.621 4.139 3.701Zm7.725 11.62-.057.029c-2.863 1.922-6.308 3.199-9.922 3.73a1.067 1.067 0 0 1-1.162-.775c-.312-1.177-1.318-1.951-2.523-1.951h-.042c-1.205 0-2.212.774-2.524 1.95a1.067 1.067 0 0 1-1.162.776c-3.614-.531-7.058-1.808-9.921-3.73-.015-.015-.156-.1-.27-.029-.127.072-.127.244-.127.244l.099 7.316c0 3.013 2.41 5.452 5.386 5.452h17.065c2.977 0 5.386-2.44 5.386-5.452l.114-7.316s0-.172-.128-.244c-.07-.043-.156-.029-.212 0Zm-12.63 6.011a1.06 1.06 0 0 1-1.062 1.076 1.068 1.068 0 0 1-1.063-1.076v-1.85c0-.589.482-1.076 1.063-1.076.595 0 1.063.487 1.063 1.076v1.85Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 3.453,
    x2: 30.345,
    y1: 1.605,
    y2: 46.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DC8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECF281"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.6ca97670fd2cac39c036b671ec4a6af7.svg";
export { ForwardRef as ReactComponent };